module.exports = __webpack_public_path__ + "static/media/21ECLAC1.91ad41cf.jpg";